import { FieldDataType } from './fieldMetadata';

export interface OperatorDef {
  value: string;
  label: string;
  needsValue: boolean;
  multiSelect?: boolean;
}

const TEXT_OPERATORS: OperatorDef[] = [
  { value: 'equals', label: 'Equals', needsValue: true },
  { value: 'not_equals', label: 'Not Equals', needsValue: true },
  { value: 'contains', label: 'Contains', needsValue: true },
  { value: 'is_empty', label: 'Is Empty', needsValue: false },
  { value: 'is_not_empty', label: 'Is Not Empty', needsValue: false },
];

const ENUM_OPERATORS: OperatorDef[] = [
  { value: 'equals', label: 'Is', needsValue: true },
  { value: 'not_equals', label: 'Is Not', needsValue: true },
  { value: 'in', label: 'In', needsValue: true, multiSelect: true },
  { value: 'not_in', label: 'Not In', needsValue: true, multiSelect: true },
  { value: 'is_empty', label: 'Is Empty', needsValue: false },
  { value: 'is_not_empty', label: 'Is Not Empty', needsValue: false },
];

const NUMBER_OPERATORS: OperatorDef[] = [
  { value: 'equals', label: 'Equals', needsValue: true },
  { value: 'not_equals', label: 'Not Equals', needsValue: true },
  { value: 'greater_than', label: 'Greater Than', needsValue: true },
  { value: 'less_than', label: 'Less Than', needsValue: true },
  { value: 'greater_or_equal', label: 'Greater or Equal', needsValue: true },
  { value: 'less_or_equal', label: 'Less or Equal', needsValue: true },
  { value: 'is_empty', label: 'Is Empty', needsValue: false },
  { value: 'is_not_empty', label: 'Is Not Empty', needsValue: false },
];

const DATE_OPERATORS: OperatorDef[] = [
  { value: 'in_last_x_days', label: 'In Last X Days', needsValue: true },
  { value: 'in_last_x_hours', label: 'In Last X Hours', needsValue: true },
  { value: 'in_next_x_days', label: 'In Next X Days', needsValue: true },
  { value: 'in_next_x_hours', label: 'In Next X Hours', needsValue: true },
  { value: 'in_the_future', label: 'In the Future', needsValue: false },
  { value: 'in_the_past', label: 'In the Past', needsValue: false },
  { value: 'before', label: 'Before', needsValue: true },
  { value: 'after', label: 'After', needsValue: true },
  { value: 'equals', label: 'On Date', needsValue: true },
  { value: 'is_empty', label: 'Is Empty', needsValue: false },
  { value: 'is_not_empty', label: 'Is Not Empty', needsValue: false },
];

const EXISTS_OPERATORS: OperatorDef[] = [
  { value: 'is_empty', label: 'Is Empty', needsValue: false },
  { value: 'is_not_empty', label: 'Is Not Empty', needsValue: false },
];

export const OPERATORS_BY_TYPE: Record<FieldDataType, OperatorDef[]> = {
  text: TEXT_OPERATORS,
  enum: ENUM_OPERATORS,
  dynamic_enum: ENUM_OPERATORS,
  number: NUMBER_OPERATORS,
  date: DATE_OPERATORS,
  exists: EXISTS_OPERATORS,
};

export function getOperatorsForType(dataType: FieldDataType): OperatorDef[] {
  return OPERATORS_BY_TYPE[dataType] ?? TEXT_OPERATORS;
}
